import { AbstractModel, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { State } from './state';

@inheritSerialization(AbstractModel)
export class InsurancePolicy extends AbstractModel {
  @autoserialize
  insurer: string;

  @autoserializeAs(Date)
  coverageStartDate: Date;

  @autoserializeAs(Date)
  coverageEndDate: Date;

  @autoserialize
  naicNumber: string;

  @autoserialize
  policyNumber: string;

  @autoserialize
  coverageDetails: string;

  @autoserialize
  insuranceCertificateUrl: string;

  @autoserializeAs(State)
  state: State;

  @autoserialize
  active: boolean;

  get timezoneAdjustedCoverageStartDate(): Date {
    return DateUtil.adjustDateFromLocalToUTC(this.coverageStartDate);
  }

  get timezoneAdjustedCoverageEndDate(): Date {
    return DateUtil.adjustDateFromLocalToUTC(this.coverageEndDate);
  }

  /**** Serialization ****/

  static OnSerialized(instance: InsurancePolicy, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.coverageStartDate)) {
      json.coverageStartDate = DateUtil.serializeDate(instance.coverageStartDate);
    }

    if (!isNullOrUndefined(instance.coverageEndDate)) {
      json.coverageEndDate = DateUtil.serializeDate(instance.coverageEndDate);
    }
  }

  static OnDeserialized(instance: InsurancePolicy, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['coverageStartDate'])) {
      instance.coverageStartDate = DateUtil.deserializeDate(json['coverageStartDate']);
    }

    if (!isNullOrUndefined(json['coverageEndDate'])) {
      instance.coverageEndDate = DateUtil.deserializeDate(json['coverageEndDate']);
    }
  }
}
